import Label from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Label/Label";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

type AssignedProps = {
  value: string | Loading;
};

function Assigned({ value }: AssignedProps) {
  return <Label value={value} />;
}

export default Assigned;
